export default __webpack_public_path__ + "static/media/ai-marker.3f17cce5.svg";